<template>
  <q-dialog v-model="filter">
    <q-card style="width: 320px">
      <div class="q-pa-md">
        <div class="row q-col-gutter-xs">
          <div class="col-md-12 col-xs-12 col-lg-12 col-xl-12">
            <q-select
              label="Types"
              v-model="type"
              outlined
              :disable="loading"
              label-color="grey-7"
              color="grey-7"
              :options="types"
              :option-label="(type) => type.name"
              dense
            >
              <template v-slot:no-option>
                <q-item>
                  <q-item-section class="text-italic text-grey">
                    There is no options.
                  </q-item-section>
                </q-item>
              </template>
              <template v-slot:append>
                <q-icon
                  size="15px"
                  style="margin-top: 3px"
                  v-if="!type == ''"
                  class="cursor-pointer"
                  name="fas fa-times"
                  @click="type = ''"
                  @click.stop="type === ''"
                />
              </template>
            </q-select>
          </div>
          <div
            style="margin-top: 5px"
            class="col-md-12 col-xs-12 col-lg-12 col-xl-12"
          >
            <q-select
              label="Select Location"
              v-model="location_id"
              outlined
              :display-value="shorter"
              multiple
              :disable="locations.length === 0 || loading"
              label-color="grey-7"
              color="grey-7"
              :options="locations"
              dense
            >
              <template v-slot:no-option>
                <q-item>
                  <q-item-section class="text-italic text-grey">
                    There is no options.
                  </q-item-section>
                </q-item>
              </template>
              <template v-slot:append>
                <q-icon
                  size="15px"
                  style="margin-top: 3px"
                  v-if="!!location_id.length > 0"
                  class="cursor-pointer"
                  name="fas fa-times"
                  @click="location_id = []"
                  @click.stop="!location_id.length === 0"
                />
              </template>
              <template v-slot:option="locations">
                <q-item
                  @click="locationFilterPusher(locations.opt)"
                  dense
                  clickable
                  v-ripple
                >
                  <q-item-section side top>
                    <q-checkbox
                      size="xs"
                      v-model="location_id"
                      :val="locations.opt"
                    />
                  </q-item-section>
                  <q-item-section>{{ locations.opt.code }}</q-item-section>
                </q-item>
              </template>
            </q-select>
          </div>
          <div
            style="margin-top: 5px"
            class="col-md-12 col-xs-12 col-lg-12 col-xl-12"
          >
            <q-select
              label="Status"
              v-model="status"
              outlined
              :disable="loading"
              label-color="grey-7"
              color="grey-7"
              :options="statusList"
              :option-label="(sta) => sta.name"
              dense
            >
              <template v-slot:no-option>
                <q-item>
                  <q-item-section class="text-italic text-grey">
                    There is no options.
                  </q-item-section>
                </q-item>
              </template>
              <template v-slot:append>
                <q-icon
                  size="15px"
                  style="margin-top: 3px"
                  v-if="!status == ''"
                  class="cursor-pointer"
                  name="fas fa-times"
                  @click="status = ''"
                  @click.stop="status === ''"
                />
              </template>
            </q-select>
          </div>
          <div
            class="col-md-12 col-xs-12 col-lg-12 col-xl-12"
            style="margin-top: 5px; text-align: right"
          >
            <q-btn
              color="negative"
              @click="filter = false"
              label="Close"
            ></q-btn>
          </div>
        </div>
      </div>
    </q-card>
  </q-dialog>
</template>

<script>
export default {
  data() {
    return { loading: false };
  },
  methods: {
    locationFilterPusher(location) {
      if (this.location_id.some((item) => item.id === location.id)) {
        const index = this.location_id
          .map((item) => item.id)
          .indexOf(location.id);
        if (index !== -1) {
          this.$store.commit("reports/REMOVE_LOCATION_ID", index);
        }
      } else {
        this.location_id = [...this.location_id, location];
      }
    },
  },
  computed: {
    shorter() {
      if (this.location_id.length > 0 && this.location_id.length < 2) {
        return this.location_id[0].code;
      } else if (this.location_id.length > 1) {
        return `${this.location_id[0].code} +${this.location_id.length - 1}`;
      }
    },
    status: {
      get() {
        return this.$store.state.reports.status;
      },
      set(val) {
        this.$store.commit("reports/SET_STATUS", val);
      },
    },
    statusList() {
      return this.$store.state.reports.statusList;
    },
    location_id: {
      get() {
        return this.$store.state.reports.location_id;
      },
      set(val) {
        this.$store.commit("reports/SET_LOCATION_ID", val);
      },
    },
    locations: {
      get() {
        return this.$store.state.reports.locations;
      },
      set(val) {
        this.$store.commit("reports/SET_LOCATIONS", val);
      },
    },
    type: {
      get() {
        return this.$store.state.reports.type;
      },
      set(val) {
        this.$store.commit("reports/SET_TYPE", val);
      },
    },
    types() {
      return this.$store.state.reports.types;
    },
    filter: {
      get() {
        return this.$store.state.reports.filter;
      },
      set(val) {
        this.$store.commit("reports/SET_FILTER", val);
      },
    },
  },
};
</script>
